import React from 'react'

import styled from 'styled-components'

import { rhythm } from '../utils/typography'

const IndexContainer = styled.div`
  padding: 1rem;
  max-width: 30rem;
`

const Line = styled.p`
  line-height: 3rem;
  font-size: 3rem;
  margin: ${rhythm(1.5)} 0;

  &:last-child {
    margin-bottom: 0;
  }

  a {
    color: hsla(0,0%,0%,0.7)
  }
`

class Index extends React.Component {
  render() {
    return (
      <IndexContainer>
        <Line>Hi! My name is William Chiu.</Line>
        <Line>My friends call me Billy Chiu—I am...</Line>
        <Line>An aspiring full stack developer</Line>
        <Line>The 142nd Head of Product at the{" "}
          <a href="http://www.columbiaspectator.com/">Columbia Daily Spectator</a>
        </Line>
        <Line>A software engineering intern at{" "}
          <a href="https://eegent.com/">EEG</a>
        </Line>
        <Line>Previously, a software engineering intern at{" "}
          <a href="http://diditlabs.com/">DIDiT</a>
        </Line>
        <Line>Pleasure to meet you!</Line>
      </IndexContainer>
    )
  }
}

export default Index

exports.frontmatter = {
  title: "Home",
  inChilly: true
}


// WEBPACK FOOTER //
// ./src/pages/index.js